import { formatDate, isoDateStringToDate } from 'lib/riskbase';
import React from 'react';
import { ISODateString } from 'types/types';
import { Txt } from 'components/Txt';
import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { theme } from 'lib/theme';
import { getCheckAvailabilityCategory } from '../Explorer/utils';
import { AseFieldInstanceCheckAvailability } from 'store/assessments/types';
import {
  API_DATE_FORMAT,
  UI_DATE_FORMAT_LONG_WITH_DAY,
  UI_TIME_FORMAT,
} from 'lib/constants';
import { addSeconds } from 'date-fns';
export const ScheduledVisitAvailabilityTimeline: React.FC<{
  availability: {
    id: string;
    startDateTime: ISODateString;
    endDateTime: ISODateString;
  }[];
}> = ({ availability }) => {
  const days = React.useMemo(
    () =>
      Object.values(
        availability.reduce<
          Record<string, AseFieldInstanceCheckAvailability[]>
        >((acc, slot) => {
          const date = formatDate(
            isoDateStringToDate(slot.startDateTime),
            API_DATE_FORMAT,
          );
          if (!acc[date]) {
            acc[date] = [];
          }
          acc[date].push(slot);
          return acc;
        }, {}),
      ),
    [availability],
  );

  if (!days.length) {
    return null;
  }

  const date = new Date();

  return (
    <Card label="Resident Availability">
      {days.map((slots) => {
        const [firstSlot] = slots;
        if (!firstSlot) {
          return null;
        }
        const firstSlotDate = isoDateStringToDate(firstSlot.startDateTime);
        const availabilityCategory = getCheckAvailabilityCategory(
          firstSlotDate,
          date,
        );
        const availabilityCategoryText = availabilityCategory?.text;
        return (
          <CardRow key={firstSlot.id} labelAlignTop>
            <Txt>
              {formatDate(firstSlotDate, UI_DATE_FORMAT_LONG_WITH_DAY) +
                (!!availabilityCategoryText
                  ? ` (${availabilityCategoryText})`
                  : '')}
            </Txt>
            <Txt
              size="xsmall"
              style={{ color: theme.colors.fieldValueText, marginTop: 2 }}
            >
              {slots
                .map(
                  (slot) =>
                    `${formatDate(isoDateStringToDate(slot.startDateTime), UI_TIME_FORMAT)}` +
                    ` – ` +
                    `${formatDate(
                      addSeconds(isoDateStringToDate(slot.endDateTime), 1),
                      UI_TIME_FORMAT,
                    )}`,
                )
                .join(', ')}
            </Txt>
          </CardRow>
        );
      })}
    </Card>
  );
};
